import { useState } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { globalStyles } from "../styles/globalStyles";
import { useEffect } from "react";
import { listNotifications } from "../src/graphql/queries";
import { useContext } from "react";
import { UserContext } from "../globalData/UserContext";
import { API } from "aws-amplify";
import { FlatList } from "react-native-gesture-handler";
import { updateNotifications } from "../src/graphql/mutations";
import Ionicons from "react-native-vector-icons/Ionicons";
import { CommunityContext } from "../globalData/ComunityContext";
import Blank from "./components/Blank";

export default function Notifications({ navigation }) {
  const [notifications, setNotifications] = useState([]);
  const [empty, setEmpty] = useState(false);
  const userData = useContext(UserContext); //get the db user from the UserContext
  const communityInfo = useContext(CommunityContext);

  let user = {};
  if (userData != null) user = userData.user;

  useEffect(() => {
    findAllNotifications();
  }, []);

  async function findAllNotifications() {
    const allnotifs = await API.graphql({ query: listNotifications });
    const notifs = allnotifs.data.listNotifications.items;
    const filteredNotifs = notifs.filter(
      (notif) =>
        notif.notificationsRecieverUId == user.data.getUsers.uId &&
        notif.community == communityInfo.currCom.cId
    );
    setNotifications(
      filteredNotifs.sort(
        (notif1, notif2) => notif1.createdAt < notif2.createdAt
      )
    );
    setEmpty(filteredNotifs.length == 0);
  }

  async function pressHandler(notif) {
    if (notif.item.type == "book requested") {
      navigation.navigate("Tabs", { screen: "My Books" });
    } else if (
      notif.item.type == "return book" ||
      notif.item.type == "request approved"
    )
      navigation.navigate("Tabs", { screen: "Borrowed" });
    else if (notif.item.type == "book added")
      navigation.navigate("Tabs", { screen: "Available" });
    await updateStatus(notif);
  }

  async function updateStatus(notif) {
    try {
      await API.graphql({
        query: updateNotifications,
        variables: {
          input: {
            id: notif.item.id,
            status: "read",
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  return (
    <View style={globalStyles.background}>
      <Ionicons
        name="close"
        size={30}
        style={styles.close}
        onPress={() => {
          navigation.navigate("Tabs");
        }}
      />
      {empty && <Blank titleText="You're all caught up!" subtitleText="" />}
      <FlatList
        data={notifications}
        renderItem={(notif) => {
          return (
            <TouchableOpacity
              style={
                notif.item.status == "read" ? styles.outerRead : styles.outer
              }
              onPress={async () => {
                await pressHandler(notif);
              }}
            >
              <View style={{ flexDirection: "row" }}>
                <Image
                  source={{
                    uri: notif.item.sender.profilePicture,
                    width: 40,
                    height: 40,
                  }}
                  style={styles.image}
                />
                <View>
                  <Text style={styles.titleText}>
                    {notif.item.sender.userName}
                  </Text>
                  <Text style={styles.text}>{notif.item.name}</Text>
                </View>
              </View>
            </TouchableOpacity>
          );
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  outerRead: {
    marginTop: 8,
    borderRadius: 5,
    backgroundColor: "#d4c0b2",
    padding: 17,
    paddingTop: 10,
    marginHorizontal: 15,
    shadowOffset: { width: 1, height: 1 },
    shadowColor: "#333",
    shadowOpacity: 0.3,
    shadowRadius: 2,
    flex: 1,
  },
  outer: {
    marginTop: 8,
    borderRadius: 5,
    backgroundColor: "#d6b092",
    padding: 17,
    paddingTop: 10,
    marginHorizontal: 15,
    shadowOffset: { width: 1, height: 1 },
    shadowColor: "#333",
    shadowOpacity: 0.3,
    shadowRadius: 2,
    flex: 1,
    flexWrap: "wrap",
  },
  titleText: {
    fontFamily: "quicksand-bold",
    fontSize: 16,
    marginBottom: 5,
    color: "#2e2c2b",
  },
  text: {
    fontFamily: "quicksand-normal",
    fontSize: 14,
    color: "#2e2c2b",
    flex: 1,
    width: "65%",
  },
  image: {
    borderRadius: 50,
    marginRight: 20,
  },
  close: {
    marginTop: 10,
    color: "",
    marginLeft: 5,
  },
});
